import React, { useEffect, useRef, useState } from "react";
import mermaid from "mermaid";

let initialized = false;
function initMermaid() {
  if (initialized) return;
  mermaid.initialize({
    startOnLoad: false,
    theme: "base",
    securityLevel: "loose",
    fontFamily: '"IBM Plex Sans", sans-serif',
    themeVariables: {
      primaryColor: "#F4F4F5",
      primaryTextColor: "#18181B",
      primaryBorderColor: "#A1A1AA",
      lineColor: "#52525B",
      secondaryColor: "#FAFAFA",
      tertiaryColor: "#FFFFFF",
      background: "#FFFFFF",
      mainBkg: "#FFFFFF",
      nodeBorder: "#27272A",
      clusterBkg: "#FAFAFA",
      clusterBorder: "#E4E4E7",
      titleColor: "#18181B",
      edgeLabelBackground: "#FFFFFF",
      quadrant1Fill: "#FAFAFA",
      quadrant2Fill: "#F4F4F5",
      quadrant3Fill: "#FAFAFA",
      quadrant4Fill: "#F4F4F5",
      quadrant1TextFill: "#18181B",
      quadrant2TextFill: "#18181B",
      quadrant3TextFill: "#18181B",
      quadrant4TextFill: "#18181B",
      quadrantTitleFill: "#18181B",
      quadrantXAxisTextFill: "#52525B",
      quadrantYAxisTextFill: "#52525B",
      quadrantInternalBorderStrokeFill: "#A1A1AA",
      quadrantExternalBorderStrokeFill: "#27272A",
      quadrantPointFill: "#18181B",
    },
    flowchart: { useMaxWidth: true, htmlLabels: true, curve: "linear" },
    quadrantChart: { useMaxWidth: true, chartWidth: 600, chartHeight: 460 },
  });
  initialized = true;
}

let counter = 0;

export default function MermaidBlock({ code }) {
  const containerRef = useRef(null);
  const [error, setError] = useState(null);
  const idRef = useRef(`mmd-${++counter}-${Math.random().toString(36).slice(2, 8)}`);

  useEffect(() => {
    initMermaid();
    let cancelled = false;
    const cleanedCode = (code || "").trim();
    if (!cleanedCode) return undefined;

    (async () => {
      try {
        const { svg } = await mermaid.render(idRef.current, cleanedCode);
        if (!cancelled && containerRef.current) {
          containerRef.current.innerHTML = svg;
          setError(null);
        }
      } catch (e) {
        if (!cancelled) setError(String(e?.message || e));
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [code]);

  if (error) {
    return (
      <div
        className="my-6 border border-ink-200 bg-ink-50 p-4 text-sm text-ink-600 font-mono whitespace-pre-wrap"
        data-testid="mermaid-fallback"
      >
        {code}
      </div>
    );
  }

  return (
    <figure
      className="my-6 border border-ink-200 bg-bone p-4 md:p-6 overflow-x-auto page-break-avoid"
      data-testid="mermaid-diagram"
    >
      <div ref={containerRef} className="flex justify-center min-h-[120px]" />
    </figure>
  );
}
